__turbopack_context__.v({
  "border": "TalesBlockImageLeft-module-scss-module__jjS_nW__border",
  "caption": "TalesBlockImageLeft-module-scss-module__jjS_nW__caption",
  "content": "TalesBlockImageLeft-module-scss-module__jjS_nW__content",
  "copy": "TalesBlockImageLeft-module-scss-module__jjS_nW__copy",
  "fade-in": "TalesBlockImageLeft-module-scss-module__jjS_nW__fade-in",
  "image": "TalesBlockImageLeft-module-scss-module__jjS_nW__image",
  "inner": "TalesBlockImageLeft-module-scss-module__jjS_nW__inner",
  "isInView": "TalesBlockImageLeft-module-scss-module__jjS_nW__isInView",
  "media": "TalesBlockImageLeft-module-scss-module__jjS_nW__media",
  "root": "TalesBlockImageLeft-module-scss-module__jjS_nW__root",
});
